<div *ngIf="!showContent" class="loading-spinner">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="showContent">

            <ag-grid-angular style="height: 200px; margin:10px" [columnDefs]="productColumnDefs"
                [defaultColDef]="defaultColDef" [rowData]="products" [autoGroupColumnDef]="autoGroupColumnDef"
                [rowGroupPanelShow]="rowGroupPanelShow" [class]="themeClass"
                (gridReady)="onGridReady($event)">
            </ag-grid-angular>

</ng-container>